import { Campaign, IGetCampaignByIdUseCase } from '../../interfaces';
import { HttpGetRequest } from '@infrastructure/axios/http-get-request';

export default class GetCampaignByIdUseCase extends HttpGetRequest<Campaign> implements IGetCampaignByIdUseCase {
  private static readonly ONE_HOUR: number = 60 * 60 * 1000;

  public async execute(language : String,id: Stringify<number>): Promise<Campaign> {
    const url = this.buildURL(`/campaign/${id}/${language}`).get();
    return (await this.dispatch(url)).data.data;
  }
}
